/**
 * 来源
 */
import { parseQuery } from '../../utils/url';

const query = parseQuery();

export const FROM = query.from || query.type;


export function isShare() {
  return FROM === 'share';
}

export function isCopyTripReturn() {
  return FROM === 'copy_trip_return';
}



// WEBPACK FOOTER //
// ./src/pages/trip/from.js